import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// ---------------------------------------------------------------------------
// Native runtime detection — Capacitor injects `window.Capacitor.isNativePlatform`
// at runtime. Flip a body data-attribute so CSS/JS can adapt (safe-area,
// no-select, hide PWA install prompt, etc.). Falls back to false on plain PWA.
// ---------------------------------------------------------------------------
(function markRuntime() {
  const isNative =
    typeof window !== "undefined" &&
    !!window.Capacitor &&
    typeof window.Capacitor.isNativePlatform === "function" &&
    window.Capacitor.isNativePlatform();
  document.body.dataset.native = isNative ? "true" : "false";
  const platform = (window.Capacitor && window.Capacitor.getPlatform && window.Capacitor.getPlatform()) || "web";
  document.body.dataset.platform = platform; // "ios" | "android" | "web"
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => { /* ignore */ });
  });
}
